<template>
    <section class="widget profiles">
        <div class="calendar" v-if="!loading">
            <v-date-picker :attributes="attrs" :is-inline="true" :is-expanded="true" :theme-styles='themeStyles' v-model="selectedDate"></v-date-picker>
            <div class="h-align-center mt-5">
                <button class="btn icon" @click="$router.push('/track/track')">
                    <svg width="26" height="26">
                        <g clip-path="url(#clip_0)">
                            <path fill="rgb(255,255,255)" stroke="none" transform="translate(3.67603 3.13873)" d="M21.4044 2.5685L21.4043 2.56844L19.4387 0.383853C19.0018 -0.108089 18.3469 -0.108089 17.855 0.274886L16.1072 1.85864L19.5476 5.68091L21.3493 4.09716C21.7862 3.71525 21.7862 3.00544 21.4044 2.5685ZM1.8567 15.0184L5.29709 18.8407L18.7299 6.44575L15.2895 2.62348L1.8567 15.0184ZM0 20.0966L0.982827 15.7283L4.47715 19.5507L0 20.0966Z" fill-rule="evenodd"/>
                        </g>
                        <g clip-path="url(#clip_1)">
                            <path fill="rgb(255,255,255)" stroke="none" transform="translate(0.342041 0.108154)" d="M0 6.13997C0 5.56916 0.0783979 5.02588 0.20769 4.50733L0.207489 4.50746C0.803264 2.27912 2.61601 0.569433 4.92263 0.129292C5.31048 0.0522676 5.72587 0 6.16601 0C9.55932 0 12.3322 2.74549 12.3322 6.1662C12.3322 8.88687 10.5717 11.2182 8.10967 12.0215C7.51411 12.2292 6.84017 12.3323 6.16619 12.3323C3.16076 12.3323 0.621715 10.1563 0.103158 7.28022C0.0261334 6.89095 0 6.52923 0 6.13997ZM2.69449 5.44127L2.69449 6.5031L2.69586 6.84011L5.44125 6.84011L5.44125 9.61162L6.86621 9.61162L6.86621 6.86624L9.61297 6.86624L9.61297 5.44127L6.86621 5.44127L6.86621 2.69588L5.44125 2.69588L5.44125 5.44127L2.69449 5.44127Z" fill-rule="evenodd"/>
                        </g>
                    </svg>
                    <span>{{textSwitch}}</span>
                </button>
            </div>
        </div>
    </section>
</template>
<script>
import Vue from "vue"
import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';
import moment from 'moment'

Vue.use(moment)

Vue.use(VCalendar, { // calendar rendering options
    firstDayOfWeek: 1,
    titlePosition: 'left',
    locale: localStorage.lang ? localStorage.lang  : 'en',
    popoverExpanded: true,
    popoverVisibility: 'visible'
})
export default {
    name: 'calendar',
    props:['id'], // profile id
    watch: {
        selectedDate() {
            this.selectDate()
        }
    },
    data() {
        return {
            dates: [],
            selectedProfile:this.id,
            selectedDate: null,
            loading: true,
            textSwitch: localStorage.lang =='en' ? 'Switch Profile' : "Changer de profil",
            themeStyles: { // calendar main styling, other styles are in scss
                wrapper: {
                    background: 'transparent',
                    color: '#4A4A4A',
                    fontWeight: '700'
                }
            },
            attrs: [
                {
                    key: 'today',
                    highlight: {
                        backgroundColor: '#1FA4DB',
                    },
                    contentStyle: {
                        color: '#fff',
                    },
                    dates: []
                }
            ]
        }
    },
    mounted: function(){
        this.getDates()
    },
    methods: {
        getDates: function() {
            this.axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
            this.axios.get(process.env.VUE_APP_URL+'profile/'+this.selectedProfile+'/symptoms/dates',{params:{id:this.selectedProfile}})
            .then(response =>{
                let d = response.data
                if(d.groups.length > 0) {
                    d.groups.map(group => {
                        let g = {start: '', end:''}
                        let start = group[0].split('-')
                        start[1] = start[1]-1
                        let end = group[1].split('-')
                        end[1] = end[1]-1
                        g.start = new Date(start[0], start[1], start[2])
                        g.end = new Date(end[0], end[1], end[2])
                        this.dates.push(g)
                    })
                }
                if(d.ungrouped_dates.length > 0) {
                    d.ungrouped_dates.map(date => {
                        let d = date.split('-')
                        d[1] = d[1]-1
                        let dd = new Date(d[0], d[1], d[2])
                        this.dates.push(dd)
                    })
                }
                this.attrs[0].dates = this.dates
                this.$nextTick(() => {
                    this.loading = false
                })
            })
            .catch(error => {
                this.$router.push({name:'track'})
            })
        },
        selectDate:function() {// converting date and checking if symptoms available
            let date = ''
            date = moment(this.selectedDate).format("YYYY-MM-DD")
            this.axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
            this.axios.get(process.env.VUE_APP_URL+'profile/'+this.selectedProfile+'/symptoms', {params:{date:date, language: localStorage.lang}})
            .then(response => {
                response.data.symptoms.length > 0 ? this.$router.push({path:"/track/summary/"+this.selectedProfile+'/'+date, params:{date:date}}) : this.$router.push({path:"/track/rate/"+this.selectedProfile+'/'+date, params:{id:this.selectedProfile, date:date}})
            })
        }
    }
}
</script>